"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.socialLinkPropType = exports.linkCtaPropType = exports.imagePropType = exports.dataPropType = exports.categoryPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _commonSetLocation = require("@mmc/common-set-location");
var imagePropType = _propTypes["default"].shape({
  image: _propTypes["default"].string,
  altText: _propTypes["default"].string
});
exports.imagePropType = imagePropType;
var linkCtaPropType = _propTypes["default"].shape({
  URL: _propTypes["default"].string,
  label: _propTypes["default"].string
});
exports.linkCtaPropType = linkCtaPropType;
var categoryPropType = _propTypes["default"].shape({
  heading: _propTypes["default"].string,
  links: _propTypes["default"].arrayOf(linkCtaPropType),
  order: _propTypes["default"].number
});
exports.categoryPropType = categoryPropType;
var socialLinkPropType = _propTypes["default"].shape({
  url: _propTypes["default"].string,
  label: _propTypes["default"].string,
  openNewTab: _propTypes["default"].bool,
  image: imagePropType
});
exports.socialLinkPropType = socialLinkPropType;
var dataPropType = _propTypes["default"].shape({
  categories: _propTypes["default"].arrayOf(categoryPropType),
  sociallinks: _propTypes["default"].arrayOf(socialLinkPropType),
  disclaimer: _propTypes["default"].arrayOf(linkCtaPropType),
  flagIcon: imagePropType,
  copyRight: _propTypes["default"].string,
  locationSelector: _commonSetLocation.dataType
});
exports.dataPropType = dataPropType;